module.exports = __webpack_public_path__ + "static/media/icono_incompleto_tarjetas.7713e3ea.svg";